import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import Login from "../pages/Login";
import Logout from "../pages/Logout";
import Root from "../authLayout/Root";
import AuthLayout from "../authLayout/AuthLayout";
import Authentication from "../authLayout/Authentication";
import {
  DashboardRole,
  DashboardOrder,
  DashboardSearchCustomer,
  CustomerInfoRoute,
  CustomerInfoGetAllOrderRoute,
  CustomerInfoOrdersRoute,
  CustomerInfoEditCustomerRoute,
  BookNewOrderRoute,
  GeneralBookingSelectionRoute,
  CartPageRoute,
  OrdersGarmentInfoRoute,
  BookingChargesInfoRoute,
  GarmentEditRoute,
  PartialMarkReadyRoute,
  DeliverOrderRoute,
  PaymentCollectionRoute,
  ViewInvoiceRoute,
  ViewQrCodeRoute,
  WalletLedgerSelectionRoute,
  CustomerAccountRoute,
  CustomerLedgerRoute,
  CustomerPackageOfferRoute,
  CustomerPackageOfferLogRoute,
  GarmentEditWithScannerRoute,
  OrdersRoute,
  DashboardPickupJobRoute,
  DashboardDeliveryJobRoute,
  WalletCollectionRoute,
  DashboardPaymentCollectionRoute,
  PickupJobRoute,
  SettingRoute,
  StoreUserRoute,
  StoreDiscountRoute,
  StoreChargesRoute,
  StorePriceCodeRoute,
  StoreUserProfileRoute,
  OrderDeliveredRoute,
  RiderJobsRoute,
  DeliveryJobRoute,
  StoreWarehouseRoute,
  SendToWarehouseRoute,
  ReceiveFromWarehouseRoute,
  ChallanListRoute,
  ChallanQrCodeListRoute,
  StoreProfileRoute,
  StoreGarmentStockRoute,
  ThankYouRoute,
  ThankYouCollectPaymentRoute,
  GarmentQrCodeListRoute,
  DashboardPaymentRefundRoute,
  PaymentCollectionReceiptRoute,
  PackagePaymentReceiptRoute,
  ViewQrCodePrintRoute,
  RiderChallanComponentRoute,
  ChallanReceiptRoute,
  WarehouseDashboardQrCodeListRoute,
  WarehouseDashboardQrCodeListReceivedReadyRoute,
  WarehouseGarmentInspectionImagesRoute,
  WarehouseChallanListRoute,
  WarehouseChallanQrCodeListRoute,
  ReceiveFromStoreRoute,
  WarehouseOrderProcessRoute,
  SendToStoreRoute,
  SelectStoreInAdminRoute,
  UserListRoute,
  StoreManagementListRoute,
  StoreManagementCreateRoute,
  StoreConfigListRoute,
  StoreConfigUserRoute,
  StoreConfigPriceRoute,
  StoreConfigPackageRoute,
  StoreConfigChargesRoute,
  StoreConfigDiscountRoute,
  StoreConfigOfferRoute,
  StoreConfigPackageOfferRoute,
  StoreConfigPaymentGatewayViewRoute,
  WarehouseManagementListRoute,
  WarehouseManagementCreateRoute,
  WarehouseConfigListRoute,
  WarehouseConfigStoresRoute,
  WarehouseProcessStageListRoute,
  WarehouseConfigUsersRoute,
  WarehouseProcessStageUsersRoute,
  ChargesAndDiscountListRoute,
  AppServiceListRoute,
  GarmentPackRoute,
  TariffListRoute,
  PriceListRoute,
  PackageTariffListRoute,
  OffersManagementRoute,
  OffersManagementCreateRoute,
  PackageOfferManagementRoute,
  PackageOfferCreateRoute,
  BrandTermAndConditionRoute,
  BrandTermAndConditionCreateRoute,
  LocalityViewRoute,
  LocalityCreateRoute,
  PaymentGatewayConfigViewRoute,
  PaymentGatewayConfigCreateRoute,
  GarmentRemarksListRoute,
  GarmentRemarksDetailListRoute,
  GarmentRemarksCreateRoute,
  BrandCustomerListRoute,
  BrandOldOrderRoute,
  AdminDashboardPickupJobRoute,
  AdminDashboardDeliveryJobRoute,
  StoreNotificationViewRoute,
  ReportsRoute,
  GarmentStockRoute,
  BarChartRoute,
  AnalyticsListRoute,
  OrderSaleAnalyticsNewRoute,
  TopPerformerNewRoute,
  TopServicesNewRoute,
  TopGarmentsNewRoute,
  ProcessStatusRoute,
  OverallRevenueRoute,
  CustomerOldOrderLedgerRoute,
  WarehouseDashboardQrCodeListStageWiseRoute,
  SubscriptionAppliedSuccessfullyRoute,
  CashbookRoute,
  IncomeExpenseRoute,
  IncomeExpenseSelectionRoute,
  StoreWiseIncomeExpenseRoute,
  DashboardPaymentCollectionReceiptRoute,
  ReportsViewRoute,
  UPIDisclaimerRoute,
  ReadyToSendToWareHouseRoute,
  ReadyToSendToStoreByWarehouseRoute,
  OrderDeliveredComponentRoute,
  QrCodeByItemRoute,
  StoreExternalWarehouseChallanRoute,
  StoreExternalWarehouseChallanAddRoute,
  StoreExternalWarehouseQrCodeRoute,
  StoreExternalWarehouseChallanQrcodeDataRoute,
  StoreExternalWHChallanComponentRoute,
  StorePrinterSettingRoute,
  BulkProcessingRoute,
  BulkPaymentRoute,
  BulkProcessingListRoute,
  BulkOutForDeliveryRoute,
  StoreReportCollectionReceiptRoute,
  WalletCollectionReceiptRoute,
  TariffManagementRoute,
  PriceListSelectionRoute,
  PackageListSelectionRoute,
  PriceListTariffRoute,
  PackageListRoute,
  GarmentTagRoute,
  OfferManagementRoute,
  PackageOfferManagementTariffRoute,
  OfferGarmentSelectionRoute,
  PackageOffersGarmentSelectionRoute,
  TrackOrderRoute,
  MyPriceListTariffRoute,
  MyPackageListRoute,
  MyOfferGarmentSelectionRoute,
  WhatsappNotificationRoute,
  TimeSlotListRoute,
  TimeSlotCreateRoute,
  PackageLogRoute,
  CustomerSubscriptionRoute,
  CustomerPackageLogRoute,
  LoyaltyPointListRoute,
  CustomerLoyaltyPointLogRoute,
  LoyaltyPointRedeemNowRoute,
  CustomerLoyaltyPointPointLogRoute,
  CustomerLoyaltyPointCashLogRoute,
  BookingDiscountInfoRoute,
  SubscriptionPackageRoute,
  SubscriptionPackageInfoStoreRoute,
  AllCustomerPackageOfferLogRoute,
  OrderDeliveredComponentMenuRoute,
  DashboardNewRoute,
  FranchiseListRoute,
  FranchiseCreateRoute,
  FranchiseStoreMapRoute,
  FranchiseStoreMappedListRoute,
  FranchiseConfigListRoute,
  FranchisesRateListRoute,
  FranchisesRateCreateRoute,
  FranchiseUserMapRoute,
  FranchiseUserMappedListRoute,
  FranchiseStoreOrderRevenueRoute,
  FranchiseStoreServiceWiseRevenueRoute,
  FranchiseStoreListRoute,
  DashboardAdminSearchCustomer,
  GarmentRFIDListRoute,
  CheckGarmentRFIDRoute,
  StoreCustomerIdConfigListRoute,
  StoreCustomerIdConfigAddRoute,
  BrandBannerListRoute,
  BrandBannerAddRoute,
  BrandBannerViewRoute,
  PromoTemplateCreateRoute,
  PromoTemplateViewRoute,
  PromoTemplateCustomerViewRoute,
  CustomerPackageOfferSubscriptionLogRoute,
  CustomerSubscriptionTransferToWalletRoute,
  CustomerPackageOfferLogNewRoute,
  PaymentModeListRoute,
  PaymentModeCreateRoute,
  B2BOrdersGarmentInfoRoute,
  B2BChallanListRoute,
  B2BGetAllOrderRoute,
  B2BDeliveredChallanViewListRoute,
  RackModelRoute,
  PackageTagViewRoute,
  B2BChallanComponentRoute,
  GeoLocationRoute,
  CustomerFeedBackRoute,
  SwitchRiderUserListRoute,
  PickupJobFormRoute,
  B2BChallanPrintRoute,
  CustomerAddressLocationRoute,
  PickupDeliveryMapRoute,
  StorePartialBookingRoute,
} from "../pages/DashboardRole";
import RequireRole from "../constants/RequireRole";
import Unauthorized from "../pages/Unauthorized";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Root />}>
      <Route element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
      </Route>
      <Route path="/" element={<Authentication />}>
        <Route
          path="/"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUPPORT_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_WAREHOUSE",
                "BY_WAREHOUSE_USER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <DashboardRole />
            </RequireRole>
          }
        />
        <Route
          path="full-dashboard"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
                "BY_ADMIN",
                "BY_SUPPORT_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <DashboardNewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DashboardOrder"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <DashboardOrder />
            </RequireRole>
          }
        />
        <Route
          path="/searchCustomer"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <DashboardSearchCustomer />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerInfo"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <CustomerInfoRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GetAllOrder"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <CustomerInfoGetAllOrderRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerInfoOrders"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <CustomerInfoOrdersRoute />
            </RequireRole>
          }
        />
        <Route
          path="/EditCustomer"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerInfoEditCustomerRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BookNewOrder"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <BookNewOrderRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GeneralBookingSelection"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <GeneralBookingSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CartPage"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <CartPageRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OrdersGarmentInfo"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
                "BY_SUPPORT_ADMIN"
              ]}
            >
              <OrdersGarmentInfoRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BookingChargesInfo"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <BookingChargesInfoRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BookingDiscountInfo"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <BookingDiscountInfoRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentEdit"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <GarmentEditRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PartialMarkReady"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <PartialMarkReadyRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DeliverOrder"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <DeliverOrderRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PaymentCollection"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <PaymentCollectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ViewInvoice"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
                "BY_SUPPORT_ADMIN"
              ]}
            >
              <ViewInvoiceRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ViewQrCode"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <ViewQrCodeRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WalletLedgerSelection"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WalletLedgerSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerAccount"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerAccountRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerLedger"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerLedgerRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerPackageOffer"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerPackageOfferRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerPackageOfferLog"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerPackageOfferLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerSubscriptionTransferToWallet"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerSubscriptionTransferToWalletRoute />
            </RequireRole>
          }
        />
        

        <Route
          path="/CustomerPackageOfferSubscriptionLog"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerPackageOfferSubscriptionLogRoute />
            </RequireRole>
          }
        />

        <Route
          path="/CustomerPackageOfferLogNew"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerPackageOfferLogNewRoute />
            </RequireRole>
          }
        />
        
        <Route
          path="/GarmentEditWithScanner"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <GarmentEditWithScannerRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Orders"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_WAREHOUSE",
                "BY_FRANCHISE_ADMIN",
                "BY_SUPPORT_ADMIN"
              ]}
            >
              <OrdersRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DashboardPickupJob"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <DashboardPickupJobRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DashboardDeliveryJob"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <DashboardDeliveryJobRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WalletCollection"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <WalletCollectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DashboardPaymentCollection"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <DashboardPaymentCollectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PickupJob"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
                "BY_SUPPORT_ADMIN"
              ]}
            >
              <PickupJobRoute />
            </RequireRole>
          }
        />

        <Route
          path="/PickupJobForm"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_SUPPORT_ADMIN",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <PickupJobFormRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Setting"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_WAREHOUSE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <SettingRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreUser"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreUserRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreDiscount"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreDiscountRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreCharges"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreChargesRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StorePriceCode"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StorePriceCodeRoute />
            </RequireRole>
          }
        />
        <Route
          path="/UserProfile"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
                "BY_SUPPORT_ADMIN"
              ]}
            >
              <StoreUserProfileRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OrderDelivered"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <OrderDeliveredRoute />
            </RequireRole>
          }
        />
        <Route
          path="/RiderJobs"
          element={
            <RequireRole roles={[
              "BY_ADMIN",
              "BY_SUB_ADMIN_USER",
              "BY_STORE",
              "BY_FRANCHISE_ADMIN",
              "BY_SUPPORT_ADMIN"
            ]}>
              <RiderJobsRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DeliveryJob"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
                "BY_SUPPORT_ADMIN"
              ]}
            >
              <DeliveryJobRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreWarehouse"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreWarehouseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/SendToWarehouse"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <SendToWarehouseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ReceiveFromWarehouse"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ReceiveFromWarehouseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ChallanList"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ChallanListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ChallanQrCodeList"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ChallanQrCodeListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreProfile"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreProfileRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreGarmentStock"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreGarmentStockRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ThankYou"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ThankYouRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ThankYouCollectPayment"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ThankYouCollectPaymentRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentQrCodeList"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <GarmentQrCodeListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/DashboardPaymentRefund"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <DashboardPaymentRefundRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PaymentCollectionReceipt"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <PaymentCollectionReceiptRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PackagePaymentReceipt"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PackagePaymentReceiptRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ViewQrCodePrint"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ViewQrCodePrintRoute />
            </RequireRole>
          }
        />
        <Route
          path="/RiderChallanComponent"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN", "BY_STORE"]}>
              <RiderChallanComponentRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ChallanReceipt"
          element={
            <RequireRole
              roles={["BY_STORE", "BY_SUB_ADMIN_USER", "BY_WAREHOUSE"]}
            >
              <ChallanReceiptRoute />
            </RequireRole>
          }
        />
        {/* warehouse Page */}
        <Route
          path="/WarehouseDashboardQrCodeList"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <WarehouseDashboardQrCodeListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseDashboardQrCodeListReceivedReady"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <WarehouseDashboardQrCodeListReceivedReadyRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseGarmentInspectionImages"
          element={
            <RequireRole roles={["BY_STORE", "BY_WAREHOUSE"]}>
              <WarehouseGarmentInspectionImagesRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseChallanList"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <WarehouseChallanListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseChallanQrCodeList"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <WarehouseChallanQrCodeListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ReceiveFromStore"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <ReceiveFromStoreRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseOrderProcess"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <WarehouseOrderProcessRoute />
            </RequireRole>
          }
        />
        <Route
          path="/SendToStore"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <SendToStoreRoute />
            </RequireRole>
          }
        />
        {/* role admin */}
        <Route
          path="/SelectStoreInAdmin"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <SelectStoreInAdminRoute />
            </RequireRole>
          }
        />
        <Route
          path="/UserList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <UserListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreManagementList"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreManagementListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreManagementCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <StoreManagementCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigList"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigUser"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigUserRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigPrice"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigPriceRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigPackage"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigPackageRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigCharges"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigChargesRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigDiscount"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigDiscountRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigOffer"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigOfferRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigPackageOffer"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigPackageOfferRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreConfigPaymentGatewayView"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreConfigPaymentGatewayViewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseManagementList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseManagementListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseManagementCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseManagementCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseConfigList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseConfigListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseConfigStores"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseConfigStoresRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseConfigUsers"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseConfigUsersRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseProcessStageList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseProcessStageListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseProcessStageUsers"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <WarehouseProcessStageUsersRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ChargesAndDiscountList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <ChargesAndDiscountListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/AppServiceList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <AppServiceListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentPack"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <GarmentPackRoute />
            </RequireRole>
          }
        />
        <Route
          path="/TariffList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <TariffListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PriceList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PriceListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PackageTariffList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PackageTariffListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OffersManagement"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <OffersManagementRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OffersManagementCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <OffersManagementCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PackageOfferManagement"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PackageOfferManagementRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PackageOfferCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PackageOfferCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BrandTermAndCondition"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <BrandTermAndConditionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BrandTermAndConditionCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <BrandTermAndConditionCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/LocalityView"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <LocalityViewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/LocalityCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <LocalityCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PaymentGatewayConfigView"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PaymentGatewayConfigViewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PaymentGatewayConfigCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PaymentGatewayConfigCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentRemarksList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <GarmentRemarksListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentRemarksDetailList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <GarmentRemarksDetailListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentRemarksCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <GarmentRemarksCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Customers"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <BrandCustomerListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OldOrder"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <BrandOldOrderRoute />
            </RequireRole>
          }
        />
        <Route
          path="/AdminDashboardPickupJob"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <AdminDashboardPickupJobRoute />
            </RequireRole>
          }
        />
        <Route
          path="/AdminDashboardDeliveryJob"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <AdminDashboardDeliveryJobRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreNotificationView"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreNotificationViewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Reports"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <ReportsRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentStock"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <GarmentStockRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BarChart"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <BarChartRoute />
            </RequireRole>
          }
        />
        <Route
          path="/AnalyticsList"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <AnalyticsListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OverallRevenue"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <OrderSaleAnalyticsNewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/TopPerformer"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <TopPerformerNewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/TopServices"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <TopServicesNewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/TopGarments"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <TopGarmentsNewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ProcessStatus"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <ProcessStatusRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OverallSummary"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <OverallRevenueRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CustomerOldOrderLedger"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerOldOrderLedgerRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WarehouseOrderStatus"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <WarehouseDashboardQrCodeListStageWiseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/SubscriptionAppliedSuccessfully"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <SubscriptionAppliedSuccessfullyRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Cashbook"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <CashbookRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Income-expense"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <IncomeExpenseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Income-expense-selection"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <IncomeExpenseSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Store-wise-income-expense"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <StoreWiseIncomeExpenseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Dashboard-payment-collection-receipt"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <DashboardPaymentCollectionReceiptRoute />
            </RequireRole>
          }
        />
        <Route
          path="/Reports-view"
          element={
            <RequireRole
              roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_FRANCHISE_ADMIN"]}
            >
              <ReportsViewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/UPIDisclaimer"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <UPIDisclaimerRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ReadyToSendToWareHouse"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <ReadyToSendToWareHouseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/ReadyToSendToStoreByWarehouse"
          element={
            <RequireRole roles={["BY_WAREHOUSE"]}>
              <ReadyToSendToStoreByWarehouseRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OrderDeliveredComponent"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <OrderDeliveredComponentRoute />
            </RequireRole>
          }
        />
        <Route
          path="/OrderDeliveredComponentMenu"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <OrderDeliveredComponentMenuRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentTags"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_RIDER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <QrCodeByItemRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreExternalWarehouseChallan"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreExternalWarehouseChallanRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreExternalWarehouseChallanAdd"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreExternalWarehouseChallanAddRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreExternalWarehouseQrCode"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreExternalWarehouseQrCodeRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreExternalWarehouseChallanQrcodeData"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreExternalWarehouseChallanQrcodeDataRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreExternalWHChallanComponent"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StoreExternalWHChallanComponentRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StorePrinterSetting"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_WAREHOUSE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <StorePrinterSettingRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BulkProcessingList"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <BulkProcessingListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BulkProcessing"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <BulkProcessingRoute />
            </RequireRole>
          }
        />
        <Route
          path="/BulkOutForDelivery"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <BulkOutForDeliveryRoute />
            </RequireRole>
          }
        />
        <Route
          path="/StoreReportCollectionReceipt"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <StoreReportCollectionReceiptRoute />
            </RequireRole>
          }
        />
        <Route
          path="/WalletCollectionReceipt"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <WalletCollectionReceiptRoute />
            </RequireRole>
          }
        />
        {/* tariff */}
        <Route
          path="/TariffManagement"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <TariffManagementRoute />
            </RequireRole>
          }
        />
        <Route
          path="tariff-list-selection"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <PriceListSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="package-list-selection"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <PackageListSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="tariff-list"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <PriceListTariffRoute />
            </RequireRole>
          }
        />
        <Route
          path="my-tariff-list"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <MyPriceListTariffRoute />
            </RequireRole>
          }
        />
        <Route
          path="package-list"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <PackageListRoute />
            </RequireRole>
          }
        />
        <Route
          path="my-package-list"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <MyPackageListRoute />
            </RequireRole>
          }
        />
        {/* garment tag is for Store */}
        <Route
          path="garment-tag"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <GarmentTagRoute />
            </RequireRole>
          }
        />
        <Route
          path="offer-management"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <OfferManagementRoute />
            </RequireRole>
          }
        />
        <Route
          path="offer-garment-selection"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <OfferGarmentSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="my-offer-garment-selection"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <MyOfferGarmentSelectionRoute />
            </RequireRole>
          }
        />
        <Route
          path="order-tracker"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <TrackOrderRoute />
            </RequireRole>
          }
        />
        <Route
          path="Whatsapp-Notification"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <WhatsappNotificationRoute />
            </RequireRole>
          }
        />
        <Route
          path="Time-Slot"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <TimeSlotListRoute />
            </RequireRole>
          }
        />
        <Route
          path="TimeSlotCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <TimeSlotCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="Package-Log"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <PackageLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="Customer-Subscription"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerSubscriptionRoute />
            </RequireRole>
          }
        />
        <Route
          path="Subscription-Package"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <SubscriptionPackageRoute />
            </RequireRole>
          }
        />
        <Route
          path="Subscription-package-info"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <SubscriptionPackageInfoStoreRoute />
            </RequireRole>
          }
        />
        <Route
          path="All-Customer-Package-Offer-Log"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <AllCustomerPackageOfferLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="Customer-Package-Log"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <CustomerPackageLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="Loyalty-Point-List"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <LoyaltyPointListRoute />
            </RequireRole>
          }
        />
        <Route
          path="Customer-Loyalty-Point-Log"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <CustomerLoyaltyPointLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="Customer-Loyalty-Point-Point-Log"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <CustomerLoyaltyPointPointLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="Customer-Loyalty-Point-Cash-Log"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER", "BY_STORE"]}>
              <CustomerLoyaltyPointCashLogRoute />
            </RequireRole>
          }
        />
        <Route
          path="LoyaltyPointRedeemNow"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <LoyaltyPointRedeemNowRoute />
            </RequireRole>
          }
        />
        <Route
          path="Franchise-List"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseListRoute />
            </RequireRole>
          }
        />
        <Route
          path="Franchise-Create"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="Franchise-Store-Mapped-List"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseStoreMappedListRoute />
            </RequireRole>
          }
        />
        <Route
          path="Franchise-Store-Map"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseStoreMapRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchise-config-list"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseConfigListRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchises-rate-list"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchisesRateListRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchises-rate-create"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchisesRateCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchise-user-create"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseUserMapRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchise-user-mapped-list"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <FranchiseUserMappedListRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchise-store-order-revenue"
          element={
            <RequireRole roles={["BY_FRANCHISE_ADMIN", "BY_ADMIN"]}>
              <FranchiseStoreOrderRevenueRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchise-store-service-wise-revenue"
          element={
            <RequireRole roles={["BY_FRANCHISE_ADMIN", "BY_ADMIN"]}>
              <FranchiseStoreServiceWiseRevenueRoute />
            </RequireRole>
          }
        />
        <Route
          path="franchise-store-list"
          element={
            <RequireRole roles={["BY_FRANCHISE_ADMIN", "BY_ADMIN"]}>
              <FranchiseStoreListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/GarmentRFIDList"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <GarmentRFIDListRoute />
            </RequireRole>
          }
        />
        <Route
          path="/CheckGarmentRFID"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <CheckGarmentRFIDRoute />
            </RequireRole>
          }
        />
        <Route
          path="/store-customer-id-config-List"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <StoreCustomerIdConfigListRoute />
            </RequireRole>
          }
        />
        <Route
          path="store-customer-id-config-add"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <StoreCustomerIdConfigAddRoute />
            </RequireRole>
          }
        />
        <Route
          path="/brand-banner-View"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <BrandBannerViewRoute />
            </RequireRole>
          }
        />

        <Route
          path="/PromoTemplateView"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <PromoTemplateViewRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PromoTemplateCreate"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <PromoTemplateCreateRoute />
            </RequireRole>
          }
        />
        <Route
          path="/PromoTemplateCustomerView"
          element={
            <RequireRole roles={["BY_ADMIN"]}>
              <PromoTemplateCustomerViewRoute />
            </RequireRole>
          }
        />

        <Route
          path="PaymentMode"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PaymentModeListRoute />
            </RequireRole>
          }
        />
        <Route
          path="PaymentModeCreate"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <PaymentModeCreateRoute />
            </RequireRole>
          }
        />
        
        <Route
          path="/B2BOrdersGarmentInfo"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <B2BOrdersGarmentInfoRoute />
            </RequireRole>
          }
        />
        <Route
          path="/B2BChallanList"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN"]}>
              <B2BChallanListRoute />
            </RequireRole>
          }
        />

        <Route
          path="/B2BDeliveredChallanViewList"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN"]}>
              <B2BDeliveredChallanViewListRoute />
            </RequireRole>
          }
        />        

        <Route
          path="/B2BGetAllOrder"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN"]}>
              <B2BGetAllOrderRoute />
            </RequireRole>
          }
        />

        <Route
          path="/RackModel"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
                "BY_SUB_ADMIN_USER",
                "BY_STORE",
                "BY_FRANCHISE_ADMIN",
              ]}
            >
              <RackModelRoute />
            </RequireRole>
          }
        />

        <Route
          path="/PackageTagView"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
              ]}
            >
              <PackageTagViewRoute />
            </RequireRole>
          }
        />

        <Route
          path="/B2BChallanComponent"
          element={
            <RequireRole
              roles={[
                "BY_STORE",
              ]}
            >
              <B2BChallanComponentRoute />
            </RequireRole>
          }
        />


        <Route
          path="/GeoLocation"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
              ]}
            >
              <GeoLocationRoute />
            </RequireRole>
          }
        />

        <Route
          path="Customer-FeedBack"
          element={
            <RequireRole
              roles={[
                "BY_ADMIN",
              ]}
            >
              <CustomerFeedBackRoute />
            </RequireRole>
          }
        />

        <Route
          path="/SwitchRiderUserList"
          element={
            <RequireRole roles={["BY_ADMIN", "BY_SUB_ADMIN_USER"]}>
              <SwitchRiderUserListRoute />
            </RequireRole>
          }
        />

        <Route
          path="/B2BChallanPrint"
          element={
            <RequireRole roles={["BY_STORE", "BY_ADMIN"]}>
              <B2BChallanPrintRoute />
            </RequireRole>
          }
        />
        

        <Route
          path="/Customer-address-location"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <CustomerAddressLocationRoute />
            </RequireRole>
          }
        />

        <Route
          path="/pickup-delivery-map"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <PickupDeliveryMapRoute />
            </RequireRole>
          }
        />


        <Route
          path="/store-partial-booking"
          element={
            <RequireRole roles={["BY_STORE"]}>
              <StorePartialBookingRoute />
            </RequireRole>
          }
        />


        <Route path="/unauthorized" element={<Unauthorized />} />
      </Route>
      <Route path="logout" element={<Logout />} />
    </Route>
  )
);

export default router;
